module.exports = __webpack_public_path__ + "static/media/opensans-bold.0a91d836.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-bold.woff
// module id = 294
// module chunks = 0